import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateSmsTemplateForm from "../../forms/CreateOrUpdateSmsTemplateForm";
import { SmsTemplateResponseDto } from "../../shared/dtos/sms/SmsTemplateResponseDto";

interface UpdateSmsTemplateModalProps {
  open: boolean;
  onClose: () => void;
  template: SmsTemplateResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateSmsTemplateModal: React.FC<UpdateSmsTemplateModalProps> = ({
  open,
  onClose,
  template,
  loading,
  error,
}) => {
  return (
    <AppModal
      open={open}
      onClose={onClose}
      title={`Edit Template: ${template.templateCode}`}
      width="sm"
      loading={loading}
    >
      <CreateOrUpdateSmsTemplateForm
        isEditing={true}
        template={template}
        loading={loading}
        error={error}
      />
    </AppModal>
  );
};

export default UpdateSmsTemplateModal;
